import toastr from 'toastr'
import { dateFormat } from 'filters'
import pagination from 'components/pagination'
import { editableText } from 'components/editable'
import { hasPermits } from 'directives'

const directives = {
  hasPermits
}

const components = {
  pagination,
  editableText,
}

if (!isServer) {
  components.JsonViewer = require('vue-json-viewer').default;
}

const filters = {
  dateFormat
}

const watch = {
  activeTab (n) {
    if (n && this.ancillary && this.ancillary.ancillary_type === 'parkguard') {
      this.loading = true;
      Promise.all([
        this.loadParkguardReservations(1),
      ]).then(() => {
        this.loading = false;
      });
    }
  },

  testingMode (n) {
    if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'parkguard') {
      this.loadParkguardReservations(1)
    }
  },

  formData (n, o) {
    if (n == o) return;

    this.form = n;
  }
}


const computed = {
  parkguard_reservations () {
    return _.cloneDeep((this.$store.state.channels.active && this.$store.state.channels.active.parkguard_reservations) || {});
  },

  errors () {
    if (this.$store.state.channels.errors) {
      return this.$store.state.channels.errors.errors;
    }
    return {}
  }
}

const methods = {
  loadParkguardReservations (page = 1) {
    this.loading = true;
    return this.$store.dispatch('channels.getParkguardReservations', {
      id: this.$route.params.id,
      params: {
        page,
        _sort: '-id',
        testing: this.testingMode ? 1 : 0,
      }
    }).then(() => {
      this.loading = false;
    });
  },

  markupValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['markup_value'] = value;

    event.stopLoading();
    event.close();
  },

  reslabFeeValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['reslab_fee_value'] = value;

    event.stopLoading();
    event.close();
  },

  heightOverSplitIntervals (r) {
    setTimeout(() => {
      let content = document.querySelector(`#ellipsis-btn-split-${r} .jv-container`);
      if (content) {
        if (content.offsetHeight < content.scrollHeight) {
          $(`#ellipsis-btn-split-${r}`).css('display', 'flex');
        } else {
          $(`#ellipsis-btn-split-${r}`).css('display', 'none');
          $(`#ellipsis-btn-split-${r} .jv-container`).css({'max-height': 'unset', 'overflow-y': 'auto'});
        }
      }
    }, 100);
    return true    
  },

  showHiddenSplitIntervals (r) {
    $(`#ellipsis-btn-split-${r} .jv-container`).css('max-height', 'unset');
    $(`.ellipsis-btn-split-${r}`).css('display', 'none');
  }
}

export default {
  name: 'parkguard-ancillary',
  props: ['formData', 'activeTab', 'ancillary', 'ancillaryIndex', 'testingMode'],
  components,
  computed,
  filters,
  methods,
  watch,
  directives,
  data () {
    return {
      loading: false,
      showParkguardReservations: {}
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'parkguard') {
        this.loadParkguardReservations();
      }
    });
  }
} 